import React from 'react';

import Dialog, { DialogProps } from '@liquidweb-dev/undercurrent/Dialog';
import DialogActions from '@liquidweb-dev/undercurrent/DialogActions';
import DialogContent from '@liquidweb-dev/undercurrent/DialogContent';
import DialogTitle from '@liquidweb-dev/undercurrent/DialogTitle';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import useServerPowerStart from 'modules/queries/server/power/useStart';
import toast from '@liquidweb-dev/undercurrent/toast';
import Button from '@liquidweb-dev/undercurrent/Button';
import ServerSpecsCard from '../SeverSpecsCard';

export interface DialogStartServerProps extends Omit<DialogProps, 'onClose'> {
	onClose: () => void;
	uniqId: string;
	domain: string;
	ip: string;
}

function DialogStartServer({
	domain,
	ip,
	onClose,
	uniqId,
	...dialogProps
}: DialogStartServerProps) {
	const { mutate: startServer, isLoading } = useServerPowerStart();

	const handleConfirm = () => {
		startServer(
			{ uniq_id: uniqId },
			{
				onSuccess: () => {
					onClose();
					toast.success('Server starting.');
				},
			},
		);
	};

	return (
		<Dialog onClose={onClose} {...dialogProps}>
			<DialogTitle onClose={onClose}>Start server</DialogTitle>
			<DialogContent
				sx={{ display: 'flex', flexDirection: 'column', gap: 200 }}
			>
				<Typography variant="body-md">
					Are you sure sure you want to start this server?
				</Typography>
				<ServerSpecsCard
					cardHeaderTitle="Selected server"
					domain={domain}
					ip={ip}
				/>
			</DialogContent>
			<DialogActions>
				<Button variant="secondary" onClick={onClose} size="large">
					Cancel
				</Button>
				<Button
					variant="primary"
					onClick={handleConfirm}
					loading={isLoading}
					size="large"
				>
					Confirm
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default DialogStartServer;
